
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";
import CustomChipLink from "@/components/CustomChipLink.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import ActivateFollowAllKeys from "@/components/ActivateFollowAllKeys.vue";
import { Getter } from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiBell, mdiBellOffOutline } from "@mdi/js";
import { ROWS_PER_PAGE } from "@/utils/constants";
import { getTokenLink } from "@/utils/misc";

@Component({
  components: { KeyStatus, CustomChipLink, LogTable, SvgIcon, ActivateFollowAllKeys },
})

export default class KeysTable extends Vue {

  get lang(): string {
    return this.$root.$i18n.locale;
  }

  @Prop({ default: () => [] })
  public keys: any[];

  @Prop({ default: false })
  public loading: boolean;

  @Prop({ default: 0 })
  public count: number;

  @Prop({ default: false })
  public showFollowed: boolean;

  @Getter private isAdmin: boolean;
  @Getter private currentUser: any;

  private mdiBell = mdiBell;
  private mdiBellOffOutline = mdiBellOffOutline;

  private headers: object[] = [
    {value: "name", sortable: false},
    {value: "relay", sortable: false},
    {value: "status", sortable: false},
    {value: "category", sortable: false},
    {value: "location", sortable: false},
    {value: "followed", sortable: false},
  ];
  private pagination: any = {
    statuses: [],
    page: 1,
    itemsPerPage: 10,
  };
  private displayKeysFilter: boolean = false;
  private keysStatus: string[] = [];
  private readonly getTokenLink = getTokenLink;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Watch("pagination", {deep: true})
  public handlerPagination(): void {
    if (this.pagination.search) {
      this.pagination.page = 1;
    }
    this.$emit("fetch-keys", this.pagination);
  }

  private mounted() {
    this.getKeysStatus();
  }

  private getKeysStatus(): Promise<void> {
    return this.$store.dispatch("keys/getStatus").then((res) => {
      this.keysStatus = res.keysStatus;
    });
  }

  private toggleFollowed(item: any): void {
    if (this.currentUser.followAllKeys || item.archivedAt) {
      return;
    }
    if (item.isFollowed) {
      this.$store.dispatch("keys/removeFollowedKey", {keyId: item.id, userId: this.currentUser.id})
        .then(() => { item.isFollowed = false; })
        .catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: err,
        });
      });
    } else {
      this.$store.dispatch("keys/addFollowedKey", {keyId: item.id, userId: this.currentUser.id})
        .then(() => { item.isFollowed = true; })
        .catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: err,
        });
      });
    }
  }

  private clickRow(item) {
    return this.$router.push({name: "key", params: {id: item.id}});
  }

  private keyRelayName: (key: any) => string = (key: any) => key?.Relays?.[0]?.name || "";

  private isKeyFollowed(item: any): boolean {
    return this.currentUser.followAllKeys || item.isFollowed;
  }
}
